import { ClickAway } from '@components/core-ui/ClickAway';
import { EntityIcon } from '@components/core-ui/EntityIcon/';
import DownIcon from '@components/core-ui/Table/SortingDirection/down.svg';
import UpIcon from '@components/core-ui/Table/SortingDirection/up.svg';
import { useAuthContext } from '@providers/AuthProvider';
import { useState } from 'react';
import { SelectedWorkspaceName } from './components/SelectedWorkspaceName';
import { WorkspaceList } from './components/WorkspaceList';

export const WorkspacesListWrapper = () => {
  const { me, workspace, organization } = useAuthContext();
  const [workspaceListOpen, setWorkspaceListOpen] = useState(false);

  if (!me || !workspace || !organization) {
    return <></>;
  }

  const multipleWorkspacesInOrg = organization.workspaces.length > 1;

  return (
    <div className="mb-[5px]">
      <ClickAway onClickAway={() => setWorkspaceListOpen(false)}>
        <div className="text-foreground-muted rounded-[5px] flex px-2 py-2.5 text-base relative cursor-pointer no-underline hover:bg-surface-muted">
          <span className="flex w-[200px] h-[30px] font-medium text-base leading-[18px] capitalize relative flex-none">
            <EntityIcon
              name={workspace.name}
              onClick={() => multipleWorkspacesInOrg && setWorkspaceListOpen(!workspaceListOpen)}
            />
            <SelectedWorkspaceName
              isOpen={workspaceListOpen}
              setWorkspaceListOpen={setWorkspaceListOpen}
              multipleWorkspacesInOrg={multipleWorkspacesInOrg}
            />
            {multipleWorkspacesInOrg ? (
              <button
                type="button"
                aria-label="Switch workspace"
                aria-expanded={workspaceListOpen}
                onClick={() => setWorkspaceListOpen(!workspaceListOpen)}
                className="w-[15px] max-xl:min-w-11 max-xl:min-h-11 ml-2.5 absolute right-0 top-0 h-full flex justify-center items-center"
              >
                {workspaceListOpen ? <UpIcon className="w-[8px] h-[8px]" /> : <DownIcon className="w-[8px] h-[8px]" />}
              </button>
            ) : null}
          </span>
        </div>

        {multipleWorkspacesInOrg && workspaceListOpen ? (
          <div className="relative">
            <WorkspaceList closeList={() => setWorkspaceListOpen(false)} />
          </div>
        ) : null}
      </ClickAway>
    </div>
  );
};
